import { createAction } from '../types';
import * as Actions from './actionTypes';

export const aclFetch = () => createAction(Actions.ACL_FETCH);
export const aclFetchSuccess = (payload) => createAction(Actions.ACL_FETCH_SUCCESS, payload);
export const aclFetchError = (error) => ({ type: Actions.ACL_FETCH_ERROR, error });
